import { Suspense } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import AppLoader from "@lxp-app/components/atoms/app-loader/appLoader";
import AppRoutes from "./routes/routes";
import AuthProviderWrapper from "@lxp-app/auth/authProviderWrapper";
import { StompAssessProvider } from "@lxp-app/stompAssessment";
import MainWrapper from "@assessment/layouts/MainWrapper";
import { usePreferredLanguageSync } from "@assessment/i18n/usePreferredLanguageSync";
import { useTranslation } from "react-i18next";
import "@lxp-app/App.css";
import "@lxp-app/index.css";
import { ToasterWrapper } from "./pages/assessment-candidate/_components/toasterWrapper";
function App() {
  usePreferredLanguageSync();
  const { t } = useTranslation();

  return (
    <>
      <Suspense
        fallback={<AppLoader loadingText={t("common.appLoaderText")} />}
      >
        <BrowserRouter>
          <AuthProviderWrapper>
            <StompAssessProvider>
              <ToasterWrapper>
                <MainWrapper>
                  <Routes>
                    <Route path="/*" element={<AppRoutes />} />
                  </Routes>
                </MainWrapper>
              </ToasterWrapper>
            </StompAssessProvider>
          </AuthProviderWrapper>
        </BrowserRouter>
      </Suspense>
    </>
  );
}

export default App;
